import { IReduxState } from 'app/store';
import { useSelector, useDispatch } from 'react-redux';
import { LoginService } from 'login/services/login.service';
import { setSingleDeleteConfirmParams } from 'features/GridSlice';
import './RemovedAssetsDeleteButton.scss';

interface RemovedAssetsDeleteButtonProps {
  params: any;
  source: any;
}

export function RemovedAssetsDeleteButton({ params, source }: RemovedAssetsDeleteButtonProps) {
  const { user } = useSelector((state: IReduxState) => state.login);
  const dispatch = useDispatch<any>();

  const onClick = () => {
    if (LoginService.isViewer(user)) {
      return;
    }

    const assetName = params.row.asset_name;

    if (!assetName) {
      console.error('Missing asset name for deletion');
      return;
    }

    // Trigger the delete confirmation popup via Redux
    dispatch(setSingleDeleteConfirmParams({
      assetName: assetName,
      visible: true
    }));
  };

  const isDeleteDisabled = (): boolean => {
    if (LoginService.isViewer(user)) {
      return true;
    }
    return false;
  };

  return (
    <div className="RemovedAssetsDeleteButton">
      <img
        className={isDeleteDisabled() ? 'disabled' : ''}
        alt="delete asset"
        src="/assets/images/trash.svg"
        onClick={onClick}
      />
    </div>
  );
}
